import { memo } from "react";
import { ListingContact as ListingContactModel, ListingOffice } from "services/api/settings/listings/types";
import { EmptyHint, InfoCard, InfoGrid, Section } from "./primitives";

interface Props {
  contacts?: ListingContactModel[];
  offices?: ListingOffice[];
}

// Sekcija "Kontakt" — djelatnici i poslovnice s oglasa (ili iz postavki oglasa).
const ListingContact: React.FC<Props> = ({ contacts = [], offices = [] }) => {
  if (contacts.length === 0 && offices.length === 0) {
    return (
      <Section title="Kontakt">
        <EmptyHint text="Kontakt nije postavljen — odaberite ga na oglasu ili u Postavke → Zadane postavke oglasa." />
      </Section>
    );
  }

  return (
    <Section title="Kontakt">
      {contacts.length > 0 && (
        <InfoGrid columns={3}>
          {contacts.map((contact) => (
            <InfoCard
              key={contact.userId}
              label={contact.fullName}
              value={[contact.mobilePhoneNumber, contact.phoneNumber, contact.email]
                .filter(Boolean)
                .join(" · ")}
            />
          ))}
        </InfoGrid>
      )}

      {offices.length > 0 && (
        <InfoGrid columns={3}>
          {offices.map((office) => (
            <InfoCard key={office.officeId} label={office.name} value={office.address} />
          ))}
        </InfoGrid>
      )}
    </Section>
  );
};

export default memo(ListingContact);
